import { KeyValue } from "@/main/models/common";
import { StateActionTypes, StateTypes } from "./stateTypes";
import { StateFilterRequest } from "@/main/models/request";

export function getStatesUser(request: StateFilterRequest): StateActionTypes {
	return {
		type: StateTypes.GET_STATES_USER,
		payload: { request },
	};
}

export function saveStatesUser(
	data: KeyValue[] | null,
	isError: boolean,
	errorMessages: string[] | null,
): StateActionTypes {
	return {
		type: StateTypes.SAVE_STATES_USER,
		payload: { data, isError, errorMessages },
	};
}

export function resetReducerStatesUser(): StateActionTypes {
	return {
		type: StateTypes.RESET_REDUCER_STATES_USER,
	};
}

export function getStatesByBodyshop(request: StateFilterRequest): StateActionTypes {
	return {
		type: StateTypes.GET_STATES_BY_BODYSHOP,
		payload: { request },
	};
}

export function saveStatesByBodyshop(
	data: KeyValue[] | null,
	isError: boolean,
	errorMessages: string[] | null,
): StateActionTypes {
	return {
		type: StateTypes.SAVE_STATES_BY_BODYSHOP,
		payload: { data, isError, errorMessages },
	};
}

export function resetReducerStatesByBodyshop(): StateActionTypes {
	return {
		type: StateTypes.RESET_REDUCER_STATES_BY_BODYSHOP,
	};
}
